<div class="inner-section my-5 px-md-5">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h2 class="card-title text-center slide-in-right" >
                    {{notice.title}} ({{notice.date}})</h2>
                <div class="row" *ngIf="notice">
                    <div class="col-12">
                        <p class="mb-4"></p>
                        <div class="row text-center mb-4" *ngIf="notice.imgUrl.length>0">
                            <div class="col-12">
                                <a href="{{notice.imgUrl[0]}}" data-lightbox="notice"><img [src]="notice.imgUrl[0]"
                                        alt="{{notice.title}}" class="img-fluid rounded"></a>
                            </div>
                        </div>
                        <h6 [innerHTML]="notice.description" class="mb-3"></h6>
                        <div *ngIf="notice.url" class="mb-3">
                            <a [href]="notice.url" target="_blank" class="btn px-4 text-white"
                                style="background-color: var(--primary);">Click Here</a>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="notice.imgUrl.length>1">
                        <h2 class="card-title slide-in-right" >Notice Gallery
                        </h2>
                        <div class="row text-center mt-4">
                            <div class="col-12 col-lg-4 mb-4" *ngFor="let url of notice.imgUrl.slice(1);">
                                <a href="{{url}}" data-lightbox="notice"> <img [src]="url" alt="{{notice.title}}"
                                        class="img-fluid rounded innerImage"></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!notice">
                    <div class="col-12">
                        <h2 class="text-center card-title">Notice</h2>
                        <p class="my-4 inner-lead">There maybe no data for this!</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>